var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfFormControlBox", {
    staticClass: "ds-textbox",
    attrs: { owner: _vm._self },
    scopedSlots: _vm._u(
      [
        {
          key: "simple",
          fn: function () {
            return [
              _c(
                "DsfTextProxy",
                _vm._b(
                  {
                    attrs: { "show-label": false },
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  },
                  "DsfTextProxy",
                  _vm._self.$props,
                  false
                )
              ),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(_vm._s(_vm.errorsMsg)),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              !_vm.readOnly
                ? _c("el-input", {
                    attrs: {
                      placeholder: _vm.placeholder,
                      rows: _vm.rows,
                      type: "textarea",
                      disabled: _vm.disabled,
                      resize: _vm.isTextAreaResize,
                      maxlength: _vm.maxlength ? _vm.maxlength : null,
                      "show-word-limit": _vm.maxlength
                        ? _vm.showWordLimit
                        : null,
                    },
                    on: {
                      blur: _vm.inputBlurHandler,
                      change: _vm.inputChangeHandler,
                    },
                    model: {
                      value: _vm.inputValue,
                      callback: function ($$v) {
                        _vm.inputValue = $$v
                      },
                      expression: "inputValue",
                    },
                  })
                : _vm.readOnly
                ? _c(
                    "div",
                    { staticClass: "ds-form-readonly" },
                    [
                      _c(
                        "DsfTextProxy",
                        _vm._b(
                          {
                            attrs: { "show-label": false },
                            model: {
                              value: _vm.value,
                              callback: function ($$v) {
                                _vm.value = $$v
                              },
                              expression: "value",
                            },
                          },
                          "DsfTextProxy",
                          _vm._self.$props,
                          false
                        )
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }